import { ProfileHeader } from "@/components/User/ProfileHeader";
import { GeoSignalsBar } from "@/components/User/GeoSignalsBar";
import { CreatorPromptCard } from "@/components/Feed/CreatorPromptCard";
import { HOMEPAGE_SEED_PROMPTS, HERO_SEED_PROMPT } from "@/data/homepage-seed";
import { useEffect, useState } from "react";

export function CreatorShowcase() {
  const [isRevealed, setIsRevealed] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsRevealed(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    const element = document.getElementById("creator-showcase");
    if (element) observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return (
    <div id="creator-showcase" className="w-full relative">
      {/* Background glow behind profile */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-2xl h-64 bg-brand-purple/10 blur-[100px] rounded-full pointer-events-none -z-10" />

      {/* 1. Header fades in first */}
      <div 
        className="transition-all duration-700 ease-out"
        style={{ 
          opacity: isRevealed ? 1 : 0, 
          transform: isRevealed ? "translateY(0)" : "translateY(20px)" 
        }}
      >
        <ProfileHeader 
          userId="u1"
          username="Navakishor"
          avatarId={1}
          tagline="Building creator infrastructure for the AI era."
          promptCount={42}
          isOwnProfile={false}
          creatorTier="top1"
        />
      </div>

      {/* 2. Stats bar slides in second */}
      <div 
        className="mt-6 transition-all duration-700 ease-out"
        style={{ 
          opacity: isRevealed ? 1 : 0, 
          transform: isRevealed ? "translateY(0)" : "translateY(20px)",
          transitionDelay: "200ms"
        }}
      >
        <GeoSignalsBar 
          totalPrompts={42}
          totalCopies={12450}
          avgGeoScore={92}
          creatorTier="top1"
          lastActive="2h ago"
        />
      </div>

      {/* 3. Prompt cards stagger in below */}
      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
        {[HERO_SEED_PROMPT, HOMEPAGE_SEED_PROMPTS[0]].map((prompt, index) => (
          <div 
            key={prompt.id}
            className="transition-all duration-700 ease-out"
            style={{ 
              opacity: isRevealed ? 1 : 0, 
              transform: isRevealed ? "translateY(0)" : "translateY(20px)",
              transitionDelay: `${400 + index * 150}ms`
            }}
          >
            <CreatorPromptCard prompt={prompt} />
          </div>
        ))}
      </div>
    </div>
  );
}
